
// import React from "react";

// const badges = [
//   {
//     src: "/images/rozet1.png",
//     alt: "10 Yıllık Tecrübe Rozeti",
//   },
//   {
//     src: "/images/rozet2.png",
//     alt: "100% Garanti Rozeti",
//   },
//   {
//     src: "/images/rozet3.png",
//     alt: "Adresten Alım Teslim Rozeti",
//   },
// ];

// const BadgeSection = () => {
//   return (
//     <div className="w-full md:w-72 mx-auto md:mx-0 flex flex-col items-center gap-4">
//       {badges.map((badge, index) => (
//         <img
//           key={index}
//           src={badge.src}
//           alt={badge.alt}
//           className="w-full rounded-xl shadow-md"
//         />
//       ))}
//     </div>
//   );
// };

// export default BadgeSection;


import React from "react";

const badges = [
  {
    src: "/images/rozet1.png",
    alt: "10 Yıllık Tecrübe Rozeti",
  },
  {
    src: "/images/rozet2.png",
    alt: "100% Garanti Rozeti",
  },
  {
    src: "/images/rozet3.png",
    alt: "Adresten Alım Teslim Rozeti",
  },
];

const BadgeSection = () => {
  return (
    <div className="w-full md:w-72 mx-auto md:mx-0 flex flex-col items-center gap-4">
      {badges.map((badge, index) => (
        <img
          key={index}
          src={badge.src}
          alt={badge.alt}
          width={300}
          height={300}
          className="w-full rounded-xl shadow-md object-contain"
        />
      ))}
    </div>
  );
};

export default BadgeSection;
